import { render } from "./InputSignature.vue?vue&type=template&id=49c81b4a&scoped=true"
import script from "./InputSignature.vue?vue&type=script&lang=js"
export * from "./InputSignature.vue?vue&type=script&lang=js"

import "./InputSignature.vue?vue&type=style&index=0&id=49c81b4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c81b4a"]])

export default __exports__